import { InlineFeedback, useFeedback } from '@mts/ui/feedback';

import React, { useState } from 'react';
import { updatePortalListing } from '../../services/api';

function normalizePhone(value) {
  return String(value || '').trim();
}

function isValidPhone(value) {
  const normalized = normalizePhone(value);
  if (!normalized) return false;
  return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(normalized.replace(/\s/g, ''));
}

export default function ListingPhoneEditor({ listing, onSaved, onCancel }) {
  const toast = useFeedback();
  const [phone, setPhone] = useState(normalizePhone(listing?.phone || listing?.phoneNumber));
  const [saving, setSaving] = useState(false);
  const [validationError, setValidationError] = useState('');



  const updatePhone = (value) => {
    setPhone(value);
    setValidationError('');


  };

  const save = async (event) => {
    event.preventDefault();
    if (!listing?.id) return;

    const trimmedPhone = normalizePhone(phone);
    if (!isValidPhone(trimmedPhone)) {
      setValidationError('Please enter a valid 10-digit phone number.');
      return;
    }

    try {
      setSaving(true);
      setValidationError('');


      const updatedListing = await updatePortalListing(listing.id, { phone: trimmedPhone });
      toast.success('Phone number updated.', { id: 'action:ListingPhoneEditor:save' });
      await onSaved?.({ updatedListing, phone: trimmedPhone });
    } catch {
      toast.error('Unable to save phone number. Please try again.', { id: 'action:ListingPhoneEditor:save' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="flex min-h-[38vh] flex-col" onSubmit={save}>
      <div className="min-h-0 flex-1 space-y-4 overflow-y-auto pb-5">
        <div className="space-y-2">
          <label className="block text-sm font-semibold text-gray-900" htmlFor="listing-phone-number">
            Phone Number
          </label>
          <input
            id="listing-phone-number"
            type="tel"
            value={phone}
            onChange={(event) => updatePhone(event.target.value)}
            placeholder="(555) 123-4567"
            className="block h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-950 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-[var(--primary)] focus:ring-2 focus:ring-[color:color-mix(in_srgb,var(--primary)_18%,transparent)]"
            autoFocus
          />
          <p className="text-xs leading-5 text-gray-500">Use the number customers should call for this business.</p>
        </div>

        {validationError ? (
          <InlineFeedback variant="error" className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-700">
            {validationError}
          </InlineFeedback>
        ) : null}


      </div>

      <div className="sticky bottom-0 -mx-5 border-t border-gray-200 bg-white px-5 py-4">
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={saving}
            className="h-9 rounded-md border border-gray-200 px-3 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={saving}
            className="h-9 rounded-md bg-[var(--primary)] px-3 text-sm font-semibold text-[var(--primary-foreground)] transition-colors hover:bg-[var(--primary-hover)] hover:text-[var(--primary-soft)] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {saving ? 'Saving...' : 'Save Phone'}
          </button>
        </div>
      </div>
    </form>
  );
}
